import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export const InstallButton = () => {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(true);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setInstalled(false);
    };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setInstalled(true);
  };
  return (
    <button onClick={install} data-testid="install-app-button"
      className="inline-flex items-center gap-1.5 rounded border border-line bg-white px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-ink transition-colors hover:border-brand hover:text-brand">
      <Download className="h-3.5 w-3.5" /> Instalar aplicativo
    </button>
  );
};

export const registerSW = () => {
  if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
  }
};
